import { LitElement, html } from 'lit';

import { LIT_CSS_VARIABLES } from '@Root/lib/lit-styles.js';
import {
  SHARED_CLASSES,
  SHARED_ELEMENTS,
} from '@Root/lib/lit-3form-block/styles.js';

import { debounce } from '@Helpers/debounce';

import { styles } from './css';

import { elasticsearchSiteSearchEnabled } from '@Helpers/helpers';

const topNav = document.querySelector('.main-nav nav');
const resizeDebounceMilliseconds = 1000.0 / 60;

class GlobalSearch extends LitElement {
  static properties = {
    inputValue: {},
  };

  static get styles() {
    return [LIT_CSS_VARIABLES, SHARED_ELEMENTS, SHARED_CLASSES, styles];
  }

  constructor() {
    super();
    this.inputValue = '';
    this.addEventListener('keyup', e => this.keyupEventFired(e));
  }

  focus() {
    this.renderRoot.querySelector('input')?.focus();
  }

  connectedCallback() {
    super.connectedCallback();
    window.addEventListener(
      'resize',
      debounce(this._handleResize, resizeDebounceMilliseconds)
    );
  }

  disconnectedCallback() {
    window.removeEventListener(
      'resize',
      debounce(this._handleResize, resizeDebounceMilliseconds)
    );
    super.disconnectedCallback();
  }

  render() {
    return html`
      <section>
        <form method="get" action="/search">
          <img src="/static/icons/SVG/search.svg" />
          <input
            type="text"
            placeholder="Search 3form"
            id="search-input"
            name="${this.inputName}"
          />
          <img
            class="close-search"
            src="/static/icons/SVG/close.svg"
            @click=${this.closeSearch}
          />
        </form>
      </section>
    `;
  }

  get inputName() {
    return elasticsearchSiteSearchEnabled() ? 'q' : 'addsearch';
  }

  keyupEventFired(event) {
    if (event.key === 'Escape') {
      this.closeSearch();
    }
  }

  closeSearch() {
    this.inputValue = '';
    document.querySelector('main').click();
  }

  _handleResize = () => {
    this.setTop();
    this.requestUpdate();
  };

  setTop() {
    this.style.top =
      window.useMobileLayout || window.useTabletLayout
        ? `${topNav.getBoundingClientRect().bottom}px`
        : '';
  }
}

customElements.define('global-search', GlobalSearch);
